import React from 'react';
import { string } from 'prop-types';

import styles from './userName.module.css';

const UserName = ({ userName }) => (
  <div className={styles.userContainer}>
    <span className={styles.userName}>{userName}</span>
    <span className={styles.userInitials}>{userName.split(' ').map((name) => name[0]).join('')}</span>
  </div>
);

UserName.propTypes = {
  userName: string.isRequired
};

export default UserName;
